var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup789(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.426,
    height: 81.032,
    viewBox: "0 0 52.426 81.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.198,
    y1: -0.243,
    x2: 0.762,
    y2: 0.739,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f174ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7556e8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M4591.746-1485.619c0,2.863.053,5.726-.008,8.586-.2,9.531-4.445,16.847-12.356,22.016a24.713,24.713,0,0,1-15.735,3.931,26.213,26.213,0,0,1-23.752-20.853,7.138,7.138,0,0,1-.176-1.18,2.21,2.21,0,0,1,1.611-2.31c.873-.276,1.77-.5,2.67-.687a1.263,1.263,0,0,1,1.728,1.227,19.659,19.659,0,0,0,9.869,14.9,19.9,19.9,0,0,0,29.548-13.661,33.2,33.2,0,0,0,.359-4.949c.052-3.107.018-6.217.013-9.324,0-1-.159-1.114-1.153-.909-1.345.276-1.595.077-1.6-1.293,0-1.508.023-3.017-.01-4.524a1.167,1.167,0,0,1,1.04-1.362c2-.446,4-.947,6-1.43,1.34-.324,1.945.126,1.947,1.48q.006,5.171,0,10.34Z",
    transform: "translate(-4539.341 1532.035)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M4537.858-1646.19c0-2.827-.222-5.675.043-8.477a24.854,24.854,0,0,1,8.623-16.611,25.669,25.669,0,0,1,15.967-6.555,26.282,26.282,0,0,1,27.175,21.307,2.435,2.435,0,0,1-1.919,3.146c-.735.216-1.478.417-2.226.583-1.1.245-1.7-.209-1.834-1.338a20.145,20.145,0,0,0-17.026-17.309A19.978,19.978,0,0,0,4544.4-1655.9a32.543,32.543,0,0,0-.478,5.394c-.08,2.06,0,4.124-.032,6.186-.009.675.194,1.055.9,1.1.273.019.537.124.812.167a1.106,1.106,0,0,1,1.056,1.252c-.025,1.631,0,3.262-.014,4.894-.009,1.011-.359,1.3-1.316,1.076-2.087-.5-4.17-1.014-6.246-1.559-1.275-.334-1.4-.534-1.4-1.875C4537.682-1641.573,4537.8-1646.19,4537.858-1646.19Z",
    transform: "translate(-4537.685 1677.879)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M4607.792-1592.938c.013-3.55.05-7.789.229-11.329.179-3.5,3.668-6.8,7.192-7.123a8.263,8.263,0,0,1,8.981,6.656,14.55,14.55,0,0,1,.166,2.432c.064,1.449.57,2.056,1.968,2.221a20.306,20.306,0,0,0,2.825.2c.872-.02,1.276-.66,1.361-1.5a14.8,14.8,0,0,0-11.231-16.03,14.42,14.42,0,0,0-17.331,11.927,16.882,16.882,0,0,0-.181,2.432c-.018,4.65-.024,7.161-.078,11.809-.006.722-.064,2.884-.064,2.884,0,4.648-.011,9.3.008,13.949a16.626,16.626,0,0,0,.182,2.432,14.418,14.418,0,0,0,17.331,11.926,14.8,14.8,0,0,0,11.231-16.03c-.084-.843-.488-1.482-1.364-1.5a20.07,20.07,0,0,0-2.822.2c-1.4.165-1.907.772-1.97,2.22a14.351,14.351,0,0,1-.164,2.433,8.267,8.267,0,0,1-8.98,6.656c-3.525-.322-7.015-3.626-7.194-7.124-.182-3.541-.067-7.1-.084-10.646,0-.555.2-.752.8-.684,1.28.145,2.574.231,3.861.27a92.9,92.9,0,0,0,16.823-.919c.822-.126,1.129-.475,1.124-1.351-.022-4.024-.022-1.637-.021-5.662a109.745,109.745,0,0,1-11.518.615c-6.943.047-7.69-.237-10.179-.32-.687-.023-.909-.324-.9-.986Z",
    transform: "translate(-4589.816 1628.888)",
    fill: "#343548"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup789);
export default __webpack_public_path__ + "static/media/group789.2002c626957ab13d14bfaaa706fe1897.svg";
export { ForwardRef as ReactComponent };